import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private readonly dataSubject = new BehaviorSubject<string>('');
  private readonly dataPermission = new BehaviorSubject<boolean>(false);
  private readonly havePermission = new BehaviorSubject<boolean>(false);
  private readonly deletePermission = new BehaviorSubject<boolean>(false);
  private readonly haveEditPermission = new BehaviorSubject<boolean>(false);
  private readonly haveAddPermission = new BehaviorSubject<boolean>(false);
  private readonly haveOnlyViewPermission = new BehaviorSubject<boolean>(false);
  private readonly isNotePending = new BehaviorSubject<boolean>(false);

  setData(data: string) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }

  setPermission(data: boolean) {
    this.dataPermission.next(data);
  }

  getPermission() {
    return this.dataPermission.asObservable();
  }

  sethaveAddPermission(data: boolean) {
    this.haveAddPermission.next(data);
  }

  gethaveAddPermission() {
    return this.haveAddPermission.asObservable();
  }

  setdeletePermission(data: boolean) {
    this.deletePermission.next(data);
  }

  getdeletePermission() {
    return this.deletePermission.asObservable();
  }

  sethaveEditPermission(data: boolean) {
    this.haveEditPermission.next(data);
  }

  gethaveEditPermission() {
    return this.haveEditPermission.asObservable();
  }

  sethavePermission(data: boolean) {
    this.havePermission.next(data);
  }
  gethavePermission() {
    return this.havePermission.asObservable();
  }

  sethaveOnlyViewPermission(data: boolean) {
    this.haveOnlyViewPermission.next(data);
  }

  gethaveOnlyViewPermission()
  {
     return this.haveOnlyViewPermission.asObservable();
  }

  setIsNotePending(data: boolean) {
    this.isNotePending.next(data);
  } 

  getIsNotePending() {
    return this.isNotePending.asObservable();
  }
}
